

















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  filters: {
    dateFilter(value: string) {
      const str = value.split('-')
      return `${str[1]}-${str[2]}`
    },
  },
})
export default class List extends Vue {
  @Prop()
  dataList!: any[]
  token: string = ''
  showDetail(taskId: string, phone: string) {
    this.$router.push(`/customer/detail/${taskId}/${phone}`)
  }
  created() {
    // this.token = this.$route.query.token
  }
}
